import React from 'react';
import { Col, Container, Row } from 'react-grid-system';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';
import Button from '../../components/Button';
import Card from '../../components/Card/index';
import PageTitle from '../../components/PageTitle/index';
import { P1 } from '../../components/Typography/index';

const Action = styled.div`
  padding: 16px 0 0;
  text-align: right;

  a {
    text-decoration: none;
  }
`;

const ManualPaymentSuccess: React.FC = () => {
  return (
    <Container>
      <Row>
        <Col lg={10} push={{ lg: 1 }}>
          <PageTitle>Payment Success</PageTitle>
          <Card>
            <P1 bold>Thank you, your payment has been received. </P1>
            <P1>
              Where applicable, if there are any outstanding charges which your co-tenant(s) has not settled, you will remain
              jointly and severally liable until this is paid off in full.
            </P1>
            <P1>You will receive a confirmation email once all charges have been settled.</P1>
          </Card>
          <Action>
            <NavLink to={`/`}>
              <Button>Take me to my payment plan</Button>
            </NavLink>
          </Action>
        </Col>
      </Row>
    </Container>
  );
};

export default ManualPaymentSuccess;
